// Shared by the KB document Versions tab and the chat bot History section; no diff library in the app.

export const DIFF_LINE_STYLES = {
  add: {
    background: 'var(--mantine-color-green-0)',
    color: 'var(--mantine-color-green-8)',
    padding: '0 8px',
    borderRadius: 2,
    whiteSpace: 'pre-wrap',
  },
  del: {
    background: 'var(--mantine-color-red-0)',
    color: 'var(--mantine-color-red-9)',
    textDecoration: 'line-through',
    padding: '0 8px',
    borderRadius: 2,
    whiteSpace: 'pre-wrap',
  },
  same: { color: 'var(--mantine-color-text)', padding: '0 8px', whiteSpace: 'pre-wrap' },
};

// A line diff (LCS) of two texts, as { kind: 'same' | 'add' | 'del', text } rows. Above 500k cells of
// changed region it falls back to a full replace, so a huge document cannot freeze the page.
export const diffLines = (oldText, newText) => {
  const a = (oldText || '').split('\n');
  const b = (newText || '').split('\n');
  let start = 0;
  while (start < a.length && start < b.length && a[start] === b[start]) start++;
  let endA = a.length;
  let endB = b.length;
  while (endA > start && endB > start && a[endA - 1] === b[endB - 1]) {
    endA--;
    endB--;
  }
  const head = a.slice(0, start).map((text) => ({ kind: 'same', text }));
  const tail = a.slice(endA).map((text) => ({ kind: 'same', text }));
  const midA = a.slice(start, endA);
  const midB = b.slice(start, endB);
  const mid = [];
  if (midA.length * midB.length > 500000) {
    // Too large for LCS — degrade to a full replace block.
    midA.forEach((text) => mid.push({ kind: 'del', text }));
    midB.forEach((text) => mid.push({ kind: 'add', text }));
  } else {
    const dp = Array.from({ length: midA.length + 1 }, () => new Array(midB.length + 1).fill(0));
    for (let i = midA.length - 1; i >= 0; i--) {
      for (let j = midB.length - 1; j >= 0; j--) {
        dp[i][j] = midA[i] === midB[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
      }
    }
    let i = 0;
    let j = 0;
    while (i < midA.length && j < midB.length) {
      if (midA[i] === midB[j]) {
        mid.push({ kind: 'same', text: midA[i] });
        i++;
        j++;
      } else if (dp[i + 1][j] >= dp[i][j + 1]) {
        mid.push({ kind: 'del', text: midA[i] });
        i++;
      } else {
        mid.push({ kind: 'add', text: midB[j] });
        j++;
      }
    }
    while (i < midA.length) mid.push({ kind: 'del', text: midA[i++] });
    while (j < midB.length) mid.push({ kind: 'add', text: midB[j++] });
  }
  return [...head, ...mid, ...tail];
};
